import { useRef, useEffect, useState } from 'react';
import './Matricula.css';
import Header from '../../componentes/js/Header';
import Footer from '../../componentes/js/Footer';
import HeroSection from './secoes/HeroSection';
import BeneficiosSection from './secoes/BeneficiosSection';
import EstatisticasSection from './secoes/EstatisticasSection';
import DepoimentosSection from './secoes/DepoimentosSection';
import DiferenciaisSection from './secoes/DiferenciaisSection';
import ChamadaAcaoSection from './secoes/ChamadaAcaoSection';

const Matricula = () => {
  const embedRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
      setIsMobile(true);
    }

    if (embedRef.current) {  // Certifica-se que o ref não está null
      const script = document.createElement('script');
      script.src = "https://www.instagram.com/embed.js";
      script.async = true;
      script.defer = true;
      embedRef.current.appendChild(script);

      return () => {
        embedRef.current.removeChild(script);
      };
    }
  }, []);

  return (
    <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
      <Header />

      <main>
      <HeroSection />

      <BeneficiosSection />

      <EstatisticasSection />

      <DepoimentosSection embedRef={embedRef} />

      <DiferenciaisSection />

      <ChamadaAcaoSection />
      </main>

      <Footer />
    </div>
  );
};

export default Matricula;
